<oa-input label="OTP Confirmation" type="otp" [(value)]="otp" [required]="true"></oa-input>
<div class="controls-row confBtn">
  <span class="spacer"></span>
  <button mat-raised-button [disabled]="isProcessing" (click)="cancel()">Cancel</button>
  <button mat-raised-button color="primary" [disabled]="!otp || isProcessing" (click)="confirm()">Confirm</button>
  <span class="spacer"></span>
</div>